<template>
  <el-empty :image="noData" :image-size="150" :description="description" :style="{ height: height+'px' }" />
</template>

<script>
import noData from "../assets/images/talent/search-empty.png";

export default {
  name: "emptyView",
  props: {
    height: {
      type: Number,
      default: 300
    },
    description: {
      type: String,
      default: '暂无数据'
    }
  },
  data() {
    return {
      noData
    }
  }
}
</script>

<style scoped>

</style>
